import { render } from "./Download.vue?vue&type=template&id=3ac663a0"
import script from "./Download.vue?vue&type=script&setup=true&lang=js"
export * from "./Download.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Bread/Resources/ui/Components/Table/Fields/Download.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3ac663a0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3ac663a0', __exports__)) {
    api.reload('3ac663a0', __exports__)
  }
  
  module.hot.accept("./Download.vue?vue&type=template&id=3ac663a0", () => {
    api.rerender('3ac663a0', render)
  })

}


export default __exports__